(function () {
    'use strict';

    function main() {
        var page = wo$('#product');
        if (!page.length) return;

        var controller = {
            init: function () {
                page.find('#product-cta-sticky').affix({
                    offset: {
                        top: function () {
                            return page.find('#nav-strip').offset().top;
                        }
                    }
                });

                var showCallback = page.attr('data-show-callback').toLowerCase() === 'true';
                if (showCallback) {
                    page.find('#callback').click();
                }

                page.find('#modem-contract input:radio')
                    .off('click')
                    .click(function () {
                        var contractTerm = parseInt(wo$(this).val());
                        controller.filterModems(contractTerm);
                    });

                WhistleOut.getAds('Broadband');
            },

            filterModems: function (contractTerm) {
                page.find('#modems [data-contract]').each(function (index, element) {
                    var $this = wo$(element);
                    if ($this.data('contract') === contractTerm) $this.show();
                    else $this.hide();
                });
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
